<template>
  <div class="payment-method" :class="{ 'active' : active }">
    <div class="header">
      <span class="payment-method-name">{{ getName }}</span>
    </div>
    <div class="body">
      <img class="ui image" :src="paymentMethodImage" :alt="name">
    </div>
    <div class="payment-method-actions">
      <div class="ui blue circular button"
           :class="(slug === 'mobile_pay' && !$store.getters.activeMerchant.mobile_pay) || (slug === 'vipps' && !$store.getters.activeMerchant.vipps) ? 'disabled' : ''"
           @click="selectPaymentMethod" v-if="!active">{{ $t('globals.buttons.select') }}
      </div>
      <div class="ui blue circular button" :class="{'disabled': !editable}" @click="deselectPaymentMethod" v-else>
        {{ $t('globals.buttons.deselect') }}
      </div>
    </div>
  </div>
</template>

<script>
import mobilepay from '../../assets/images/payment_methods/mobilepay.png'
import nets from '../../assets/images/payment_methods/nets.jpg'
import vipps from '../../assets/images/payment_methods/vipps.png'

export default {
  name: 'PaymentMethod',

  props: {
    id: {
      required: true,
      type: Number
    },
    name: {
      required: true,
      type: String
    },
    slug: {
      required: true,
      type: String
    },
    active: {
      required: false,
      default: false,
      type: Boolean
    },
    editable: {
      required: false,
      default: true,
      type: Boolean
    },
    paymentPlan: {
      required: false,
      default: 'instant',
      type: String
    }
  },

  data() {
    return {}
  },

  methods: {
    selectPaymentMethod () {
      this.$emit('select', this.slug)
    },

    deselectPaymentMethod () {
      this.$emit('deselect')
    }
  },

  computed: {
    getName () {
      switch (this.slug) {
        case 'nets':
          return this.$t('modals.newsubscriptionmodal.payment_method.pay_by_card')
        case 'vipps':
        case 'mobile_pay':
          return 'Vipps/MobilePay'
      }
    },

    paymentMethodImage () {
      switch (this.slug) {
        case 'nets':
          return nets
        case 'mobile_pay':
          return mobilepay
        case 'vipps':
          return vipps
      }
    }
  }
}
</script>

<style lang="scss">
.payment-method {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  flex-basis: 30%;
  margin: 1rem;
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  background: #EBF0F6;
  border: 1px solid rgba(0, 0, 0, 0);
  transition: all .6s ease;

  &.active {
    &:before {
      opacity: 1;
    }

    background: #00c1f7;

    .header {
      color: #fff;
    }
  }

  &:before {
    content: "";
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 0;
    opacity: 0;
    transition: all .6s ease;
    background: #00c1f7;
    background: linear-gradient(20deg, #007ef3, #00c1f7);
  }

  .header {
    padding: 20px 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 5;

    .payment-method-name {
      font-size: 18px;
      font-weight: bold;
    }
  }

  .body {
    width: 100%;
    display: flex;
    align-items: center;
    flex-flow: column;
    background: #fff;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    z-index: 5;

    .image {
      height: auto;

      @media only screen and (max-width: 768px) {
        height: 130px;
      }

      @media only screen and (max-width: 480px) {
        height: 100px;
      }
    }
  }

  .payment-method-actions {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    z-index: 5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payment/PaymentMethod.vue